import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_TICKETS } from "../../../utils/constants";
import { TicketInterface } from "../../../models/TicketModule/Ticket";
import ticketService from "../../../services/ticketService/ticketService";

interface AddTicketsContext {
  previousTickets: TicketInterface[];
}

const useAddTicket = () => {
  const queryClient = useQueryClient();

  return useMutation<
    TicketInterface,
    Error,
    TicketInterface,
    AddTicketsContext
  >({
    mutationFn: ticketService.Save,

    onMutate: () => {
      const previousTickets =
        queryClient.getQueryData<TicketInterface[]>([CACHE_KEY_TICKETS]) || [];

      return { previousTickets };
    },

    onSuccess: (savedTicket, newTicket) => {
      queryClient.setQueryData<TicketInterface[]>(
        [CACHE_KEY_TICKETS],
        (tickets) => (tickets ? [savedTicket, ...tickets] : [savedTicket])
      );
    },

    onError: (error, newTicket, context) => {
      if (!context) return;

      queryClient.setQueryData<TicketInterface[]>(
        [CACHE_KEY_TICKETS],
        context.previousTickets
      );
    },
  });
};

export default useAddTicket;
